import React, { useEffect } from "react";
import "./i18n";
import { useTranslation } from "react-i18next";
import { BrowserRouter, Navigate, Outlet, Route, Routes, useLocation, useParams } from "react-router-dom";
import { isLocale, localeMeta, preferredLanguage, STORAGE_KEY } from "./i18n/locales";
import { DemoBookingProvider } from "./components/DemoBookingDialog";
import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";

function LocaleRedirect() {
  const location = useLocation();
  const locale = preferredLanguage();
  return (
    <Navigate
      to={`/${locale}${location.search}${location.hash}`}
      replace
    />
  );
}

function LanguageLayout() {
  const { lng } = useParams();
  const location = useLocation();
  const { i18n } = useTranslation();
  const known = isLocale(lng);

  useEffect(() => {
    if (!known) return;
    if (i18n.resolvedLanguage !== lng) i18n.changeLanguage(lng);
    try {
      window.localStorage.setItem(STORAGE_KEY, lng);
    } catch {
      // Ignore storage failures. The URL remains the source of truth.
    }
    document.documentElement.lang = localeMeta(lng).htmlLang;
    const description = document.querySelector('meta[name="description"]');
    if (description) description.setAttribute("content", i18n.t("meta.description"));
  }, [known, lng, i18n]);

  if (!known) {
    const next = preferredLanguage();
    return (
      <Navigate
        to={`/${next}${location.pathname}${location.search}${location.hash}`}
        replace
      />
    );
  }

  return <Outlet />;
}

function UnknownLocalePage() {
  const { lng } = useParams();
  return <Navigate to={`/${lng}`} replace />;
}

function App() {
  return (
    <BrowserRouter>
      <DemoBookingProvider>
        <Routes>
          <Route path="/" element={<LocaleRedirect />} />
          <Route path="/:lng" element={<LanguageLayout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="solutions" element={<Products />} />
            <Route path="products" element={<Navigate to="../solutions" replace />} />
            <Route path="contact" element={<Contact />} />
            <Route path="privacy" element={<PrivacyPolicy />} />
            <Route path="*" element={<UnknownLocalePage />} />
          </Route>
        </Routes>
      </DemoBookingProvider>
    </BrowserRouter>
  );
}

export default App;
